import { useState } from "react";
import { Link } from "react-router-dom";

function CtaDotGrid() {
  const dots = [];
  const cols = 5, rows = 5;
  for (let r = 0; r < rows; r++) {
    for (let c = 0; c < cols; c++) {
      const highlighted = r === 3 && c === 1;
      dots.push(
        <circle key={`${r}-${c}`}
          cx={c * 48 + 20} cy={r * 48 + 20} r={highlighted ? 20 : 16}
          fill={highlighted ? "#9333ea" : "#c084fc"}
          opacity={highlighted ? 0.5 : 0.25 + r * 0.06}
        />
      );
    }
  }
  return (
    <svg viewBox="0 0 260 260" style={{
      width: "clamp(160px, 30vw, 260px)",
      height: "clamp(160px, 30vw, 260px)",
      position: "absolute",
      bottom: 0,
      left: 0,
      pointerEvents: "none",
    }}>
      {dots}
    </svg>
  );
}

function ArrowIcon({ size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M5 12h14M12 5l7 7-7 7" />
    </svg>
  );
}

function CTASection({ heading }) {
  const [hovered, setHovered] = useState(false);
  const [btnHovered, setBtnHovered] = useState(false);

  return (
    <section style={{
      background: "#13121f",
      padding: "clamp(24px, 4vw, 48px) clamp(16px, 3vw, 32px)",
      boxSizing: "border-box",
    }}>
      <div
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{
          maxWidth: 1400,
          margin: "0 auto",
          background: hovered ? "#b06fe8" : "#c084fc",
          borderRadius: 24,
          padding: "clamp(40px, 7vw, 80px) clamp(20px, 6vw, 64px)",
          position: "relative",
          overflow: "hidden",
          minHeight: "clamp(220px, 35vw, 320px)",
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: "clamp(24px, 4vw, 40px)",
          transition: "background 0.4s",
          boxShadow: hovered
            ? "0 32px 80px rgba(192,132,252,0.25)"
            : "0 0px 0px rgba(0,0,0,0)",
          cursor: "default",
        }}
      >
        <CtaDotGrid />

        {/* Left: tag + headline */}
        <div style={{ position: "relative", zIndex: 1, flex: "1 1 280px" }}>
          <span style={{
            display: "inline-block",
            background: "rgba(255,255,255,0.25)",
            color: "#1e0a30",
            fontSize: "0.72rem",
            fontWeight: 700,
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            padding: "5px 12px",
            borderRadius: 6,
            marginBottom: 20,
          }}>
            Contact Us
          </span>

          <h2
            style={{
              fontSize: "clamp(2rem, 5vw, 4rem)",
              fontWeight: 600,
              color: "#1a0a2e",
              margin: 0,
              lineHeight: 1.1,
              letterSpacing: "-0.02em",
            }}
          >
            {heading
              ?.split(" ")
              .reduce((acc, word, i) => {
                if (i % 2 === 0) {
                  acc.push([word]); 
                } else {
                  acc[acc.length - 1].push(word);
                }
                return acc;
              }, [])
              .map((pair, i) => (
                <span key={i}>
                  {pair.join(" ")}
                  <br />
                </span>
              ))}
          </h2>
        </div>

        {/* Right: CTA button */}
        <div style={{
          position: "relative",
          zIndex: 1,
          flex: "0 0 auto",
          display: "flex",
          alignItems: "flex-end",
          paddingBottom: 4,
        }}>
          <Link to="/login"
            onMouseEnter={() => setBtnHovered(true)}
            onMouseLeave={() => setBtnHovered(false)}
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: btnHovered ? 14 : 10,
              background: btnHovered ? "#1a0a2e" : "#1a0a2e",
              color: "#ffffff",
              border: "none",
              borderRadius: 999,
              padding: "clamp(12px, 2vw, 16px) clamp(24px, 3vw, 36px)",
              fontSize: "clamp(0.875rem, 1.5vw, 1rem)",
              fontWeight: 600,
              cursor: "pointer",
              letterSpacing: "0.01em",
              fontFamily: "inherit",
              transition: "gap 0.3s, transform 0.3s, box-shadow 0.3s",
              transform: btnHovered ? "scale(1.04)" : "scale(1)",
              boxShadow: btnHovered
                ? "0 12px 32px rgba(26,10,46,0.3)"
                : "0 4px 12px rgba(26,10,46,0.15)",
              whiteSpace: "nowrap",
            }}>
            login
            <div style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 28,
              height: 28,
              borderRadius: "50%",
              background: "rgba(255,255,255,0.15)",
              transition: "transform 0.3s",
              transform: btnHovered ? "rotate(-40deg)" : "rotate(0deg)",
              flexShrink: 0,
            }}>
              <ArrowIcon size={14} />
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}

export default function SectionLast({ heading }) {
  return (
    <div>
      <CTASection heading={heading} />
    </div>
  );
}